import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: '[core-menu-horizontal-item]',
	templateUrl: './item.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CoreMenuHorizontalItemComponent {
	@Input()
	item: any;
}
